
const ActionTypes = {
    LOADING: "LOADING",
    ADDEDITLOADING: "ADDEDITLOADING",
    INDEXLOADING: "INDEXLOADING",
    LOGINREQUEST: "LOGINREQUEST",
    LOGINREQUESTFAILED: "LOGINREQUESTFAILED",
    LOGINREQUESTSUCCESS: "LOGINREQUESTSUCCESS",
    LOGOUT: "LOGOUT", //
    GETDASHBOARD: "GETDASHBOARD",
    GETDASHBOARDSUCCESS: "GETDASHBOARDSUCCESS",
    GETDASHBOARDFAILED: "GETDASHBOARDFAILED",
    GETLOGS: "GETLOGS",
    GETLOGSSUCCESS: "GETLOGSSUCCESS",
    GETLOGSFAILED: "GETLOGSFAILED",
    GETCUSTOMERTYPE: "GETCUSTOMERTYPE",
    GETCUSTOMERTYPESUCCESS: "GETCUSTOMERTYPESUCCESS",
    GETCUSTOMERTYPEFAILED: "GETCUSTOMERTYPEFAILED",
    GETCUSTOMERTYPEBYID: "GETCUSTOMERTYPEBYID",
    GETCUSTOMERTYPEBYIDSUCCESS: "GETCUSTOMERTYPEBYIDSUCCESS",
    GETCUSTOMERTYPEBYIDFAILED: "GETCUSTOMERTYPEBYIDFAILED",
    TOGGLECUSTOMERTYPE: "TOGGLECUSTOMERTYPE",
    TOGGLECUSTOMERTYPESUCCESS: "TOGGLECUSTOMERTYPESUCCESS",
    TOGGLECUSTOMERTYPEFAILED: "TOGGLECUSTOMERTYPEFAILED",
    TOGGLELOGS: "TOGGLELOGS",
    TOGGLELOGSSUCCESS: "TOGGLELOGSSUCCESS",
    TOGGLELOGSFAILED: "TOGGLELOGSFAILED",
    SAVECUSTOMERTYPE: "SAVECUSTOMERTYPE",
    SAVECUSTOMERTYPESUCCESS: "SAVECUSTOMERTYPESUCCESS",
    SAVECUSTOMERTYPEFAILED: "SAVECUSTOMERTYPEFAILED",
    UPDATECUSTOMERTYPE: "UPDATECUSTOMERTYPE",
    UPDATECUSTOMERTYPESUCCESS: "UPDATECUSTOMERTYPESUCCESS",
    UPDATECUSTOMERTYPEFAILED: "UPDATECUSTOMERTYPEFAILED", // 
    GETINSURANCECOMPANY: "GETINSURANCECOMPANY",
    GETINSURANCECOMPANYSUCCESS: "GETINSURANCECOMPANYSUCCESS",
    GETINSURANCECOMPANYFAILED: "GETINSURANCECOMPANYFAILED",
    GETINSURANCECOMPANYBYID: "GETINSURANCECOMPANYBYID",
    GETINSURANCECOMPANYBYIDSUCCESS: "GETINSURANCECOMPANYBYIDSUCCESS",
    GETINSURANCECOMPANYBYIDFAILED: "GETINSURANCECOMPANYBYIDFAILED",
    TOGGLEINSURANCECOMPANY: "TOGGLEINSURANCECOMPANY",
    TOGGLEINSURANCECOMPANYSUCCESS: "TOGGLEINSURANCECOMPANYSUCCESS",
    TOGGLEINSURANCECOMPANYFAILED: "TOGGLEINSURANCECOMPANYFAILED",
    SAVEINSURANCECOMPANY: "SAVEINSURANCECOMPANY",
    SAVEINSURANCECOMPANYSUCCESS: "SAVEINSURANCECOMPANYSUCCESS",
    SAVEINSURANCECOMPANYFAILED: "SAVEINSURANCECOMPANYFAILED",
    UPDATEINSURANCECOMPANY: "UPDATEINSURANCECOMPANY",
    UPDATEINSURANCECOMPANYSUCCESS: "UPDATEINSURANCECOMPANYSUCCESS",
    UPDATEINSURANCECOMPANYFAILED: "UPDATEINSURANCECOMPANYFAILED", //
    GETINSURANCETYPE: "GETINSURANCETYPE",
    GETINSURANCETYPESUCCESS: "GETINSURANCETYPESUCCESS",
    GETINSURANCETYPEFAILED: "GETINSURANCETYPEFAILED",
    GETINSURANCETYPEBYID: "GETINSURANCETYPEBYID",
    GETINSURANCETYPEBYIDSUCCESS: "GETINSURANCETYPEBYIDSUCCESS",
    GETINSURANCETYPEBYIDFAILED: "GETINSURANCETYPEBYIDFAILED",
    TOGGLEINSURANCETYPE: "TOGGLEINSURANCETYPE",
    TOGGLEINSURANCETYPESUCCESS: "TOGGLEINSURANCETYPESUCCESS",
    TOGGLEINSURANCETYPEFAILED: "TOGGLEINSURANCETYPEFAILED",
    SAVEINSURANCETYPE: "SAVEINSURANCETYPE",
    SAVEINSURANCETYPESUCCESS: "SAVEINSURANCETYPESUCCESS",
    SAVEINSURANCETYPEFAILED: "SAVEINSURANCETYPEFAILED",
    UPDATEINSURANCETYPE: "UPDATEINSURANCETYPE",
    UPDATEINSURANCETYPESUCCESS: "UPDATEINSURANCETYPESUCCESS",
    UPDATEINSURANCETYPEFAILED: "UPDATEINSURANCETYPEFAILED", // 
    GETCLIENT: "GETCLIENT",
    GETCLIENTSUCCESS: "GETCLIENTSUCCESS",
    GETCLIENTFAILED: "GETCLIENTFAILED",
    GETCLIENTBYID: "GETCLIENTBYID",
    GETCLIENTBYIDSUCCESS: "GETCLIENTBYIDSUCCESS",
    GETCLIENTBYIDFAILED: "GETCLIENTBYIDFAILED",
    TOGGLECLIENT: "TOGGLECLIENT",
    TOGGLECLIENTSUCCESS: "TOGGLECLIENTSUCCESS",
    TOGGLECLIENTFAILED: "TOGGLECLIENTFAILED",
    SAVECLIENT: "SAVECLIENT",
    SAVECLIENTSUCCESS: "SAVECLIENTSUCCESS",
    SAVECLIENTFAILED: "SAVECLIENTFAILED",
    UPDATECLIENT: "UPDATECLIENT",
    UPDATECLIENTSUCCESS: "UPDATECLIENTSUCCESS",
    UPDATECLIENTFAILED: "UPDATECLIENTFAILED", //
    GETSTATE: "GETSTATE",
    GETSTATESUCCESS: "GETSTATESUCCESS",
    GETSTATEFAILED: "GETSTATEFAILED",
    GETSTATEBYID: "GETSTATEBYID",
    GETSTATEBYIDSUCCESS: "GETSTATEBYIDSUCCESS",
    GETSTATEBYIDFAILED: "GETSTATEBYIDFAILED",
    TOGGLESTATE: "TOGGLESTATE",
    TOGGLESTATESUCCESS: "TOGGLESTATESUCCESS",
    TOGGLESTATEFAILED: "TOGGLESTATEFAILED",
    SAVESTATE: "SAVESTATE",
    SAVESTATESUCCESS: "SAVESTATESUCCESS",
    SAVESTATEFAILED: "SAVESTATEFAILED",
    UPDATESTATE: "UPDATESTATE",
    UPDATESTATESUCCESS: "UPDATESTATESUCCESS",
    UPDATESTATEFAILED: "UPDATESTATEFAILED", //
    GETCOLOR: "GETCOLOR",
    GETCOLORSUCCESS: "GETCOLORSUCCESS",
    GETCOLORFAILED: "GETCOLORFAILED",
    GETCOLORBYID: "GETCOLORBYID",
    GETCOLORBYIDSUCCESS: "GETCOLORBYIDSUCCESS",
    GETCOLORBYIDFAILED: "GETCOLORBYIDFAILED",
    TOGGLECOLOR: "TOGGLECOLOR",
    TOGGLECOLORSUCCESS: "TOGGLECOLORSUCCESS",
    TOGGLECOLORFAILED: "TOGGLECOLORFAILED",
    SAVECOLOR: "SAVECOLOR",
    SAVECOLORSUCCESS: "SAVECOLORSUCCESS",
    SAVECOLORFAILED: "SAVECOLORFAILED",
    UPDATECOLOR: "UPDATECOLOR",
    UPDATECOLORSUCCESS: "UPDATECOLORSUCCESS",
    UPDATECOLORFAILED: "UPDATECOLORFAILED", //
    UPDATESTATEFAILED: "UPDATESTATEFAILED", //
    GETVEHICLETYPE: "GETVEHICLETYPE",
    GETVEHICLETYPESUCCESS: "GETVEHICLETYPESUCCESS",
    GETVEHICLETYPEFAILED: "GETVEHICLETYPEFAILED",
    GETVEHICLETYPEBYID: "GETVEHICLETYPEBYID",
    GETVEHICLETYPEBYIDSUCCESS: "GETVEHICLETYPEBYIDSUCCESS",
    GETVEHICLETYPEBYIDFAILED: "GETVEHICLETYPEBYIDFAILED",
    TOGGLEVEHICLETYPE: "TOGGLEVEHICLETYPE",
    TOGGLEVEHICLETYPESUCCESS: "TOGGLEVEHICLETYPESUCCESS",
    TOGGLEVEHICLETYPEFAILED: "TOGGLEVEHICLETYPEFAILED",
    SAVEVEHICLETYPE: "SAVEVEHICLETYPE",
    SAVEVEHICLETYPESUCCESS: "SAVEVEHICLETYPESUCCESS",
    SAVEVEHICLETYPEFAILED: "SAVEVEHICLETYPEFAILED",
    UPDATEVEHICLETYPE: "UPDATEVEHICLETYPE",
    UPDATEVEHICLETYPESUCCESS: "UPDATEVEHICLETYPESUCCESS",
    UPDATEVEHICLETYPEFAILED: "UPDATEVEHICLETYPEFAILED", //
    GETVEHICLEMAKER: "GETVEHICLEMAKER",
    GETVEHICLEMAKERSUCCESS: "GETVEHICLEMAKERSUCCESS",
    GETVEHICLEMAKERFAILED: "GETVEHICLEMAKERFAILED",
    GETVEHICLEMAKERBYID: "GETVEHICLEMAKERBYID",
    GETVEHICLEMAKERBYIDSUCCESS: "GETVEHICLEMAKERBYIDSUCCESS",
    GETVEHICLEMAKERBYIDFAILED: "GETVEHICLEMAKERBYIDFAILED",
    TOGGLEVEHICLEMAKER: "TOGGLEVEHICLEMAKER",
    TOGGLEVEHICLEMAKERSUCCESS: "TOGGLEVEHICLEMAKERSUCCESS",
    TOGGLEVEHICLEMAKERFAILED: "TOGGLEVEHICLEMAKERFAILED",
    SAVEVEHICLEMAKER: "SAVEVEHICLEMAKER",
    SAVEVEHICLEMAKERSUCCESS: "SAVEVEHICLEMAKERSUCCESS",
    SAVEVEHICLEMAKERFAILED: "SAVEVEHICLEMAKERFAILED",
    UPDATEVEHICLEMAKER: "UPDATEVEHICLEMAKER",
    UPDATEVEHICLEMAKERSUCCESS: "UPDATEVEHICLEMAKERSUCCESS",
    UPDATEVEHICLEMAKERFAILED: "UPDATEVEHICLEMAKERFAILED", //
    GETVENDOR: "GETVENDOR",
    GETVENDORSUCCESS: "GETVENDORSUCCESS",
    GETVENDORFAILED: "GETVENDORFAILED",
    GETVENDORBYID: "GETVENDORBYID",
    GETVENDORBYIDSUCCESS: "GETVENDORBYIDSUCCESS",
    GETVENDORBYIDFAILED: "GETVENDORBYIDFAILED",
    TOGGLEVENDOR: "TOGGLEVENDOR",
    TOGGLEVENDORSUCCESS: "TOGGLEVENDORSUCCESS",
    TOGGLEVENDORFAILED: "TOGGLEVENDORFAILED",
    SAVEVENDOR: "SAVEVENDOR",
    SAVEVENDORSUCCESS: "SAVEVENDORSUCCESS",
    SAVEVENDORFAILED: "SAVEVENDORFAILED",
    UPDATEVENDOR: "UPDATEVENDOR",
    UPDATEVENDORSUCCESS: "UPDATEVENDORSUCCESS",
    UPDATEVENDORFAILED: "UPDATEVENDORFAILED", //
    GETPOLICE: "GETPOLICE",
    GETPOLICESUCCESS: "GETPOLICESUCCESS",
    GETPOLICEFAILED: "GETPOLICEFAILED",
    GETPOLICEBYID: "GETPOLICEBYID",
    GETPOLICEBYIDSUCCESS: "GETPOLICEBYIDSUCCESS",
    GETPOLICEBYIDFAILED: "GETPOLICEBYIDFAILED",
    TOGGLEPOLICE: "TOGGLEPOLICE",
    TOGGLEPOLICESUCCESS: "TOGGLEPOLICESUCCESS",
    TOGGLEPOLICEFAILED: "TOGGLEPOLICEFAILED",
    SAVEPOLICE: "SAVEPOLICE",
    SAVEPOLICESUCCESS: "SAVEPOLICESUCCESS",
    SAVEPOLICEFAILED: "SAVEPOLICEFAILED",
    UPDATEPOLICE: "UPDATEPOLICE",
    UPDATEPOLICESUCCESS: "UPDATEPOLICESUCCESS",
    UPDATEPOLICEFAILED: "UPDATEPOLICEFAILED", //
    GETPOLICEREPORT: "GETPOLICEREPORT",
    GETPOLICEREPORTSUCCESS: "GETPOLICEREPORTSUCCESS",
    GETPOLICEREPORTFAILED: "GETPOLICEREPORTFAILED",
    GETPOLICEREPORTBYID: "GETPOLICEREPORTBYID",
    GETPOLICEREPORTBYIDSUCCESS: "GETPOLICEREPORTBYIDSUCCESS",
    GETPOLICEREPORTBYIDFAILED: "GETPOLICEREPORTBYIDFAILED",
    TOGGLEPOLICEREPORT: "TOGGLEPOLICEREPORT",
    TOGGLEPOLICEREPORTSUCCESS: "TOGGLEPOLICEREPORTSUCCESS",
    TOGGLEPOLICEREPORTFAILED: "TOGGLEPOLICEREPORTFAILED",
    SAVEPOLICEREPORT: "SAVEPOLICEREPORT",
    SAVEPOLICEREPORTSUCCESS: "SAVEPOLICEREPORTSUCCESS",
    SAVEPOLICEREPORTFAILED: "SAVEPOLICEREPORTFAILED",
    UPDATEPOLICEREPORT: "UPDATEPOLICEREPORT",
    UPDATEPOLICEREPORTSUCCESS: "UPDATEPOLICEREPORTSUCCESS",
    UPDATEPOLICEREPORTFAILED: "UPDATEPOLICEREPORTFAILED", //
    GETCOVERAGE: "GETCOVERAGE",
    GETCOVERAGESUCCESS: "GETCOVERAGESUCCESS",
    GETCOVERAGEFAILED: "GETCOVERAGEFAILED",
    GETCOVERAGEBYID: "GETCOVERAGEBYID",
    GETCOVERAGEBYIDSUCCESS: "GETCOVERAGEBYIDSUCCESS",
    GETCOVERAGEBYIDFAILED: "GETCOVERAGEBYIDFAILED",
    TOGGLECOVERAGE: "TOGGLECOVERAGE",
    TOGGLECOVERAGESUCCESS: "TOGGLECOVERAGESUCCESS",
    TOGGLECOVERAGEFAILED: "TOGGLECOVERAGEFAILED",
    SAVECOVERAGE: "SAVECOVERAGE",
    SAVECOVERAGESUCCESS: "SAVECOVERAGESUCCESS",
    SAVECOVERAGEFAILED: "SAVECOVERAGEFAILED",
    UPDATECOVERAGE: "UPDATECOVERAGE",
    UPDATECOVERAGESUCCESS: "UPDATECOVERAGESUCCESS",
    UPDATECOVERAGEFAILED: "UPDATECOVERAGEFAILED", //
    GETPAYMENTTYPE: "GETPAYMENTTYPE",
    GETPAYMENTTYPESUCCESS: "GETPAYMENTTYPESUCCESS",
    GETPAYMENTTYPEFAILED: "GETPAYMENTTYPEFAILED",
    GETPAYMENTTYPEBYID: "GETPAYMENTTYPEBYID",
    GETPAYMENTTYPEBYIDSUCCESS: "GETPAYMENTTYPEBYIDSUCCESS",
    GETPAYMENTTYPEBYIDFAILED: "GETPAYMENTTYPEBYIDFAILED",
    TOGGLEPAYMENTTYPE: "TOGGLEPAYMENTTYPE",
    TOGGLEPAYMENTTYPESUCCESS: "TOGGLEPAYMENTTYPESUCCESS",
    TOGGLEPAYMENTTYPEFAILED: "TOGGLEPAYMENTTYPEFAILED",
    SAVEPAYMENTTYPE: "SAVEPAYMENTTYPE",
    SAVEPAYMENTTYPESUCCESS: "SAVEPAYMENTTYPESUCCESS",
    SAVEPAYMENTTYPEFAILED: "SAVEPAYMENTTYPEFAILED",
    UPDATEPAYMENTTYPE: "UPDATEPAYMENTTYPE",
    UPDATEPAYMENTTYPESUCCESS: "UPDATEPAYMENTTYPESUCCESS",
    UPDATEPAYMENTTYPEFAILED: "UPDATEPAYMENTTYPEFAILED", //
    GETLPO: "GETLPO",
    GETLPOSUCCESS: "GETLPOSUCCESS",
    GETLPOFAILED: "GETLPOFAILED",
    GETLPOBYID: "GETLPOBYID",
    GETLPOBYIDSUCCESS: "GETLPOBYIDSUCCESS",
    GETLPOBYIDFAILED: "GETLPOBYIDFAILED",
    TOGGLELPO: "TOGGLELPO",
    TOGGLELPOSUCCESS: "TOGGLELPOSUCCESS",
    TOGGLELPOFAILED: "TOGGLELPOFAILED",
    SAVELPO: "SAVELPO",
    SAVELPOSUCCESS: "SAVELPOSUCCESS",
    SAVELPOFAILED: "SAVELPOFAILED",
    UPDATELPO: "UPDATELPO",
    UPDATELPOSUCCESS: "UPDATELPOSUCCESS",
    UPDATELPOFAILED: "UPDATELPOFAILED", //
    GETINSURANCESTATEMENTSUCCESS: "GETINSURANCESTATEMENTSUCCESS",
    GETINSURANCESTATEMENTFAILED: "GETINSURANCESTATEMENTFAILED",
    GETINVESTIGATIONSCHEDULESUCCESS: "GETINVESTIGATIONSCHEDULESUCCESS",
    GETINVESTIGATIONSCHEDULEFAILED: "GETINVESTIGATIONSCHEDULEFAILED",
    GETESTIMATESCHEDULESUCCESS: "GETESTIMATESCHEDULESUCCESS",
    GETESTIMATESCHEDULEFAILED: "GETESTIMATESCHEDULEFAILED",
    GETPRICESTATEMENTSUCCESS: "GETPRICESTATEMENTSUCCESS",
    GETPRICESTATEMENTFAILED: "GETPRICESTATEMENTFAILED",
    GETCOSTSTATEMENTSUCCESS: "GETCOSTSTATEMENTSUCCESS",
    GETCOSTSTATEMENTFAILED: "GETCOSTSTATEMENTFAILED",
    GETJOBCARDSCHEDULESUCCESS: "GETJOBCARDSCHEDULESUCCESS",
    GETJOBCARDSCHEDULEFAILED: "GETJOBCARDSCHEDULEFAILED",
    GETSTATEMENTMEETHAQTAKAFULINSURANCESUCCESS: "GETSTATEMENTMEETHAQTAKAFULINSURANCESUCCESS",
    GETSTATEMENTMEETHAQTAKAFULINSURANCEFAILED: "GETSTATEMENTMEETHAQTAKAFULINSURANCEFAILED",
    GETVEHICLE: "GETVEHICLE",
    GETVEHICLESUCCESS: "GETVEHICLESUCCESS",
    GETVEHICLEFAILED: "GETVEHICLEFAILED",
    GETVEHICLEBYID: "GETVEHICLEBYID",
    GETVEHICLEBYIDSUCCESS: "GETVEHICLEBYIDSUCCESS",
    GETVEHICLEBYIDFAILED: "GETVEHICLEBYIDFAILED",
    TOGGLEVEHICLE: "TOGGLEVEHICLE",
    TOGGLEVEHICLESUCCESS: "TOGGLEVEHICLESUCCESS",
    TOGGLEVEHICLEFAILED: "TOGGLEVEHICLEFAILED",
    SAVEVEHICLE: "SAVEVEHICLE",
    SAVEVEHICLESUCCESS: "SAVEVEHICLESUCCESS",
    SAVEVEHICLEFAILED: "SAVEVEHICLEFAILED",
    UPDATEVEHICLE: "UPDATEVEHICLE",
    UPDATEVEHICLESUCCESS: "UPDATEVEHICLESUCCESS",
    UPDATEVEHICLEFAILED: "UPDATEVEHICLEFAILED", //
    GETJOBCARD: "GETJOBCARD",
    GETJOBCARDSUCCESS: "GETJOBCARDSUCCESS",
    GETPARALLELJOBCARD: "GETPARALLELJOBCARD",
    GETALLJOBCARD: "GETALLJOBCARD",
    GETALLJOBCARDSUCCESS: "GETALLJOBCARDSUCCESS",
    GETALLJOBCARDFAILED: "GETALLJOBCARDFAILED",
    GETPARALLELJOBCARDSUCCESS: "GETPARALLELJOBCARDSUCCESS",
    GETJOBCARDIDSUCCESS: "GETJOBCARDIDSUCCESS",
    GETJOBCARDIDFAILED: "GETJOBCARDIDFAILED",
    GETJOBCARDFAILED: "GETJOBCARDFAILED",
    GETPARALLELJOBCARDFAILED: "GETPARALLELJOBCARDFAILED",
    GETJOBCARDBYID: "GETJOBCARDBYID",
    GETJOBCARDBYIDSUCCESS: "GETJOBCARDBYIDSUCCESS",
    GETJOBCARDBYIDFAILED: "GETJOBCARDBYIDFAILED",
    GETJOBCARDBYINSURANCEID: "GETJOBCARDBYINSURANCEID",
    GETJOBCARDBYINSURANCEIDSUCCESS: "GETJOBCARDBYINSURANCEIDSUCCESS",
    GETJOBCARDBYINSURANCEIDFAILED: "GETJOBCARDBYINSURANCEIDFAILED",
    GETJOBCARDBYCUSTOMERID: "GETJOBCARDBYCUSTOMERID",
    GETJOBCARDBYCUSTOMERIDSUCCESS: "GETJOBCARDBYCUSTOMERIDSUCCESS",
    GETJOBCARDBYCUSTOMERIDFAILED: "GETJOBCARDBYCUSTOMERIDFAILED",
    GETJOBCARDBYESTIMATEID: "GETJOBCARDBYESTIMATEID",
    GETJOBCARDBYESTIMATEIDSUCCESS: "GETJOBCARDBYESTIMATEIDSUCCESS",
    GETJOBCARDBYESTIMATEIDFAILED: "GETJOBCARDBYESTIMATEIDFAILED",
    GETJOBCARDBYINSURANCECOMPANYID: "GETJOBCARDBYINSURANCECOMPANYID",
    GETJOBCARDBYINSURANCECOMPANYIDSUCCESS: "GETJOBCARDBYINSURANCECOMPANYIDSUCCESS",
    GETJOBCARDBYINSURANCECOMPANYIDFAILED: "GETJOBCARDBYINSURANCECOMPANYIDFAILED",
    TOGGLEJOBCARD: "TOGGLEJOBCARD",
    TOGGLEJOBCARDSUCCESS: "TOGGLEJOBCARDSUCCESS",
    TOGGLEJOBCARDFAILED: "TOGGLEJOBCARDFAILED",
    SAVEJOBCARD: "SAVEJOBCARD",
    SAVEJOBCARDSUCCESS: "SAVEJOBCARDSUCCESS",
    SAVEJOBCARDFAILED: "SAVEJOBCARDFAILED",
    UPDATEJOBCARD: "UPDATEJOBCARD",
    UPDATEJOBCARDSUCCESS: "UPDATEJOBCARDSUCCESS",
    UPDATEJOBCARDFAILED: "UPDATEJOBCARDFAILED", //
    GETVEHICLECODE: "GETVEHICLECODE",
    GETVEHICLECODESUCCESS: "GETVEHICLECODESUCCESS",
    GETVEHICLECODEFAILED: "GETVEHICLECODEFAILED",
    GETVEHICLECODEBYID: "GETVEHICLECODEBYID",
    GETVEHICLECODEBYIDSUCCESS: "GETVEHICLECODEBYIDSUCCESS",
    GETVEHICLECODEBYIDFAILED: "GETVEHICLECODEBYIDFAILED",
    TOGGLEVEHICLECODE: "TOGGLEVEHICLECODE",
    TOGGLEVEHICLECODESUCCESS: "TOGGLEVEHICLECODESUCCESS",
    TOGGLEVEHICLECODEFAILED: "TOGGLEVEHICLECODEFAILED",
    SAVEVEHICLECODE: "SAVEVEHICLECODE",
    SAVEVEHICLECODESUCCESS: "SAVEVEHICLECODESUCCESS",
    SAVEVEHICLECODEFAILED: "SAVEVEHICLECODEFAILED",
    SAVEUSER: "SAVEUSER",
    SAVEUSERSUCCESS: "SAVEUSERSUCCESS",
    SAVEUSERFAILED: "SAVEUSERFAILED",
    UPDATEVEHICLECODE: "UPDATEVEHICLECODE",
    UPDATEVEHICLECODESUCCESS: "UPDATEVEHICLECODESUCCESS",
    UPDATEVEHICLECODEFAILED: "UPDATEVEHICLECODEFAILED", //
    GETVEHICLEMODEL: "GETVEHICLEMODEL",
    GETVEHICLEMODELSUCCESS: "GETVEHICLEMODELSUCCESS",
    GETVEHICLEMODELFAILED: "GETVEHICLEMODELFAILED",
    GETVEHICLEMODELBYID: "GETVEHICLEMODELBYID",
    GETVEHICLEMODELBYIDSUCCESS: "GETVEHICLEMODELBYIDSUCCESS",
    GETVEHICLEMODELBYIDFAILED: "GETVEHICLEMODELBYIDFAILED",
    GETVEHICLEMODELBYMAKEIDSUCCESS: "GETVEHICLEMODELBYMAKEIDSUCCESS",
    GETVEHICLEMODELBYMAKEIDFAILED: "GETVEHICLEMODELBYMAKEIDFAILED",
    TOGGLEVEHICLEMODEL: "TOGGLEVEHICLEMODEL",
    TOGGLEVEHICLEMODELSUCCESS: "TOGGLEVEHICLEMODELSUCCESS",
    TOGGLEVEHICLEMODELFAILED: "TOGGLEVEHICLEMODELFAILED",
    SAVEVEHICLEMODEL: "SAVEVEHICLEMODEL",
    SAVEVEHICLEMODELSUCCESS: "SAVEVEHICLEMODELSUCCESS",
    SAVEVEHICLEMODELFAILED: "SAVEVEHICLEMODELFAILED",
    UPDATEVEHICLEMODEL: "UPDATEVEHICLEMODEL",
    UPDATEVEHICLEMODELSUCCESS: "UPDATEVEHICLEMODELSUCCESS",
    UPDATEVEHICLEMODELFAILED: "UPDATEVEHICLEMODELFAILED", //
    UPDATEUSER: "UPDATEUSER",
    UPDATEUSERSUCCESS: "UPDATEUSERSUCCESS",
    UPDATEUSERFAILED: "UPDATEUSERFAILED", //
    GETCUSTOMER: "GETCUSTOMER",
    GETCUSTOMERSUCCESS: "GETCUSTOMERSUCCESS",
    GETCUSTOMERFAILED: "GETCUSTOMERFAILED",
    GETCUSTOMERBYID: "GETCUSTOMERBYID",
    GETCUSTOMERBYIDSUCCESS: "GETCUSTOMERBYIDSUCCESS",
    GETCUSTOMERBYIDFAILED: "GETCUSTOMERBYIDFAILED",
    TOGGLECUSTOMER: "TOGGLECUSTOMER",
    TOGGLECUSTOMERSUCCESS: "TOGGLECUSTOMERSUCCESS",
    TOGGLECUSTOMERFAILED: "TOGGLECUSTOMERFAILED",
    SAVECUSTOMER: "SAVECUSTOMER",
    SAVECUSTOMERSUCCESS: "SAVECUSTOMERSUCCESS",
    SAVECUSTOMERFAILED: "SAVECUSTOMERFAILED",
    UPDATECUSTOMER: "UPDATECUSTOMER",
    UPDATECUSTOMERSUCCESS: "UPDATECUSTOMERSUCCESS",
    UPDATECUSTOMERFAILED: "UPDATECUSTOMERFAILED", //
    GETUSER: "GETUSER",
    GETUSERSUCCESS: "GETUSERSUCCESS",
    GETUSERFAILED: "GETUSERFAILED",
    GETPERMISSIONS: "GETPERMISSIONS",
    GETPERMISSIONSSUCCESS: "GETPERMISSIONSSUCCESS",
    GETPERMISSIONSFAILED: "GETPERMISSIONSFAILED",
    GETPERMISSIONSBYID: "GETPERMISSIONSBYID",
    GETPERMISSIONSBYIDSUCCESS: "GETPERMISSIONSBYIDSUCCESS",
    GETPERMISSIONSBYIDFAILED: "GETPERMISSIONSBYIDFAILED",
    SAVEPERMISSIONS: "SAVEPERMISSIONS",
    SAVEPERMISSIONSSUCCESS: "SAVEPERMISSIONSSUCCESS",
    SAVEPERMISSIONSFAILED: "SAVEPERMISSIONSFAILED",
    GETUSERBYID: "GETUSERBYID",
    GETUSERBYIDSUCCESS: "GETUSERBYIDSUCCESS",
    GETUSERBYIDFAILED: "GETUSERBYIDFAILED",
    GETSUPPLIER: "GETSUPPLIER",
    GETSUPPLIERSUCCESS: "GETSUPPLIERSUCCESS",
    GETSUPPLIERFAILED: "GETSUPPLIERFAILED",
    GETSUPPLIERBYID: "GETSUPPLIERBYID",
    GETSUPPLIERBYIDSUCCESS: "GETSUPPLIERBYIDSUCCESS",
    GETSUPPLIERBYIDFAILED: "GETSUPPLIERBYIDFAILED",
    TOGGLESUPPLIER: "TOGGLESUPPLIER",
    TOGGLESUPPLIERSUCCESS: "TOGGLESUPPLIERSUCCESS",
    TOGGLESUPPLIERFAILED: "TOGGLESUPPLIERFAILED",
    SAVESUPPLIER: "SAVESUPPLIER",
    SAVESUPPLIERSUCCESS: "SAVESUPPLIERSUCCESS",
    SAVESUPPLIERFAILED: "SAVESUPPLIERFAILED",
    UPDATESUPPLIER: "UPDATESUPPLIER",
    UPDATESUPPLIERSUCCESS: "UPDATESUPPLIERSUCCESS",
    UPDATESUPPLIERFAILED: "UPDATESUPPLIERFAILED", //
    GETPRODUCTCATEGORY: "GETPRODUCTCATEGORY",
    GETPRODUCTCATEGORYSUCCESS: "GETPRODUCTCATEGORYSUCCESS",
    GETPRODUCTCATEGORYFAILED: "GETPRODUCTCATEGORYFAILED",
    GETPRODUCTCATEGORYBYID: "GETPRODUCTCATEGORYBYID",
    GETPRODUCTCATEGORYBYIDSUCCESS: "GETPRODUCTCATEGORYBYIDSUCCESS",
    GETPRODUCTCATEGORYBYIDFAILED: "GETPRODUCTCATEGORYBYIDFAILED",
    TOGGLEPRODUCTCATEGORY: "TOGGLEPRODUCTCATEGORY",
    TOGGLEPRODUCTCATEGORYSUCCESS: "TOGGLEPRODUCTCATEGORYSUCCESS",
    TOGGLEPRODUCTCATEGORYFAILED: "TOGGLEPRODUCTCATEGORYFAILED",
    SAVEPRODUCTCATEGORY: "SAVEPRODUCTCATEGORY",
    SAVEPRODUCTCATEGORYSUCCESS: "SAVEPRODUCTCATEGORYSUCCESS",
    SAVEPRODUCTCATEGORYFAILED: "SAVEPRODUCTCATEGORYFAILED",
    UPDATEPRODUCTCATEGORY: "UPDATEPRODUCTCATEGORY",
    UPDATEPRODUCTCATEGORYSUCCESS: "UPDATEPRODUCTCATEGORYSUCCESS",
    UPDATEPRODUCTCATEGORYFAILED: "UPDATEPRODUCTCATEGORYFAILED", //
    GETPRODUCT: "GETPRODUCT",
    GETPRODUCTSUCCESS: "GETPRODUCTSUCCESS",
    GETPRODUCTFAILED: "GETPRODUCTFAILED",
    GETPRODUCTBYID: "GETPRODUCTBYID",
    GETPRODUCTBYIDSUCCESS: "GETPRODUCTBYIDSUCCESS",
    GETPRODUCTBYIDFAILED: "GETPRODUCTBYIDFAILED",
    GETPRODUCTBYCATEGORYID: "GETPRODUCTBYCATEGORYID",
    GETPRODUCTBYCATEGORYIDSUCCESS: "GETPRODUCTBYCATEGORYIDSUCCESS",
    GETPRODUCTBYCATEGORYIDFAILED: "GETPRODUCTBYCATEGORYIDFAILED",
    TOGGLEPRODUCT: "TOGGLEPRODUCT",
    TOGGLEPRODUCTSUCCESS: "TOGGLEPRODUCTSUCCESS",
    TOGGLEPRODUCTFAILED: "TOGGLEPRODUCTFAILED",
    SAVEPRODUCT: "SAVEPRODUCT",
    SAVEPRODUCTSUCCESS: "SAVEPRODUCTSUCCESS",
    SAVEPRODUCTFAILED: "SAVEPRODUCTFAILED",
    UPDATEPRODUCT: "UPDATEPRODUCT",
    UPDATEPRODUCTSUCCESS: "UPDATEPRODUCTSUCCESS",
    UPDATEPRODUCTFAILED: "UPDATEPRODUCTFAILED", //
    GETDRIVINGLICENSE: "GETDRIVINGLICENSE",
    GETDRIVINGLICENSESUCCESS: "GETDRIVINGLICENSESUCCESS",
    GETDRIVINGLICENSEFAILED: "GETDRIVINGLICENSEFAILED",
    GETDRIVINGLICENSEBYID: "GETDRIVINGLICENSEBYID",
    GETDRIVINGLICENSEBYIDSUCCESS: "GETDRIVINGLICENSEBYIDSUCCESS",
    GETDRIVINGLICENSEBYIDFAILED: "GETDRIVINGLICENSEBYIDFAILED",
    GETDRIVINGLICENSEBYCATEGORYID: "GETDRIVINGLICENSEBYCATEGORYID",
    GETDRIVINGLICENSEBYCATEGORYIDSUCCESS: "GETDRIVINGLICENSEBYCATEGORYIDSUCCESS",
    GETDRIVINGLICENSEBYCATEGORYIDFAILED: "GETDRIVINGLICENSEBYCATEGORYIDFAILED",
    TOGGLEDRIVINGLICENSE: "TOGGLEDRIVINGLICENSE",
    TOGGLEDRIVINGLICENSESUCCESS: "TOGGLEDRIVINGLICENSESUCCESS",
    TOGGLEDRIVINGLICENSEFAILED: "TOGGLEDRIVINGLICENSEFAILED",
    SAVEDRIVINGLICENSE: "SAVEDRIVINGLICENSE",
    SAVEDRIVINGLICENSESUCCESS: "SAVEDRIVINGLICENSESUCCESS",
    SAVEDRIVINGLICENSEFAILED: "SAVEDRIVINGLICENSEFAILED",
    UPDATEDRIVINGLICENSE: "UPDATEDRIVINGLICENSE",
    UPDATEDRIVINGLICENSESUCCESS: "UPDATEDRIVINGLICENSESUCCESS",
    UPDATEDRIVINGLICENSEFAILED: "UPDATEDRIVINGLICENSEFAILED", //
    GETINVESTIGATION: "GETINVESTIGATION",
    GETINVESTIGATIONSUCCESS: "GETINVESTIGATIONSUCCESS",
    GETINVESTIGATIONFAILED: "GETINVESTIGATIONFAILED",
    GETPARALLELINVESTIGATION: "GETPARALLELINVESTIGATION",
    GETPARALLELINVESTIGATIONSUCCESS: "GETPARALLELINVESTIGATIONSUCCESS",
    GETPARALLELINVESTIGATIONFAILED: "GETPARALLELINVESTIGATIONFAILED",
    GETINVESTIGATIONBYID: "GETINVESTIGATIONBYID",
    GETINVESTIGATIONBYIDSUCCESS: "GETINVESTIGATIONBYIDSUCCESS",
    GETINVESTIGATIONBYIDFAILED: "GETINVESTIGATIONBYIDFAILED",
    GETINVESTIGATIONBYVEHICLEREPLACEMENTID: "GETINVESTIGATIONBYVEHICLEREPLACEMENTID",
    GETINVESTIGATIONBYVEHICLEREPLACEMENTIDSUCCESS: "GETINVESTIGATIONBYVEHICLEREPLACEMENTIDSUCCESS",
    GETINVESTIGATIONBYVEHICLEREPLACEMENTIDFAILED: "GETINVESTIGATIONBYVEHICLEREPLACEMENTIDFAILED",
    TOGGLEINVESTIGATION: "TOGGLEINVESTIGATION",
    TOGGLEINVESTIGATIONSUCCESS: "TOGGLEINVESTIGATIONSUCCESS",
    TOGGLEINVESTIGATIONFAILED: "TOGGLEINVESTIGATIONFAILED",
    SAVEINVESTIGATION: "SAVEINVESTIGATION",
    SAVEINVESTIGATIONSUCCESS: "SAVEINVESTIGATIONSUCCESS",
    SAVEINVESTIGATIONFAILED: "SAVEINVESTIGATIONFAILED",
    UPDATEINVESTIGATION: "UPDATEINVESTIGATION",
    UPDATEINVESTIGATIONSUCCESS: "UPDATEINVESTIGATIONSUCCESS",
    UPDATEINVESTIGATIONFAILED: "UPDATEINVESTIGATIONFAILED", //
    GETESTIMATE: "GETESTIMATE",
    GETESTIMATESUCCESS: "GETESTIMATESUCCESS",
    GETESTIMATEFAILED: "GETESTIMATEFAILED",
    GETPARALLELESTIMATE: "GETPARALLELESTIMATE",
    GETPARALLELESTIMATESUCCESS: "GETPARALLELESTIMATESUCCESS",
    GETPARALLELESTIMATEFAILED: "GETPARALLELESTIMATEFAILED",
    GETESTIMATEBYID: "GETESTIMATEBYID",
    GETESTIMATEBYIDSUCCESS: "GETESTIMATEBYIDSUCCESS",
    GETESTIMATEBYIDFAILED: "GETESTIMATEBYIDFAILED",
    GETESTIMATEBYINVESTIGATIONID: "GETESTIMATEBYINVESTIGATIONID",
    GETESTIMATEBYINVESTIGATIONIDSUCCESS: "GETESTIMATEBYINVESTIGATIONIDSUCCESS",
    GETESTIMATEBYINVESTIGATIONIDFAILED: "GETESTIMATEBYINVESTIGATIONIDFAILED",
    TOGGLEESTIMATE: "TOGGLEESTIMATE",
    TOGGLEESTIMATESUCCESS: "TOGGLEESTIMATESUCCESS",
    TOGGLEESTIMATEFAILED: "TOGGLEESTIMATEFAILED",
    SAVEESTIMATE: "SAVEESTIMATE",
    SAVEESTIMATESUCCESS: "SAVEESTIMATESUCCESS",
    SAVEESTIMATEFAILED: "SAVEESTIMATEFAILED",
    UPDATEESTIMATE: "UPDATEESTIMATE",
    UPDATEESTIMATESUCCESS: "UPDATEESTIMATESUCCESS",
    UPDATEESTIMATEFAILED: "UPDATEESTIMATEFAILED", //
    GETVEHICLEBYCUSTOMERID: "GETVEHICLEBYCUSTOMERID",
    GETVEHICLEBYCUSTOMERIDSUCCESS: "GETVEHICLEBYCUSTOMERIDSUCCESS",
    GETVEHICLEBYCUSTOMERIDFAILED: "GETVEHICLEBYCUSTOMERIDFAILED", // 
    GETPRODUCTATTRIBUTE: "GETPRODUCTATTRIBUTE",
    GETPRODUCTATTRIBUTESUCCESS: "GETPRODUCTATTRIBUTESUCCESS",
    GETPRODUCTATTRIBUTEFAILED: "GETPRODUCTATTRIBUTEFAILED", // 
    GETPRODUCTATTRIBUTEVALUE: "GETPRODUCTATTRIBUTEVALUE",
    GETPRODUCTATTRIBUTEVALUESUCCESS: "GETPRODUCTATTRIBUTEVALUESUCCESS",
    GETPRODUCTATTRIBUTEVALUEFAILED: "GETPRODUCTATTRIBUTEVALUEFAILED", // 
    GETPERFORMAINVOICESUCCESS: "GETPERFORMAINVOICESUCCESS",
    GETPERFORMAINVOICEBYIDSUCCESS: "GETPERFORMAINVOICEBYIDSUCCESS",
    GETPERFORMAINVOICEBYIDFAILED: "GETPERFORMAINVOICEBYIDFAILED",
    GETINVOICESBYPARTNERIDSUCCESS: "GETINVOICESBYPARTNERIDSUCCESS",
    GETINVOICESBYPARTNERIDFAILED: "GETINVOICESBYPARTNERIDFAILED",
    GETPERFORMAINVOICEFAILED: "GETPERFORMAINVOICEFAILED",
    UPDATEPERFORMAINVOICE: "UPDATEPERFORMAINVOICE",
    UPDATEPERFORMAINVOICESUCCESS: "UPDATEPERFORMAINVOICESUCCESS",
    UPDATEPERFORMAINVOICEFAILED: "UPDATEPERFORMAINVOICEFAILED",
    SAVEPERFORMAINVOICE: "SAVEPERFORMAINVOICE",
    SAVEPERFORMAINVOICESUCCESS: "SAVEPERFORMAINVOICESUCCESS",
    SAVEPERFORMAINVOICEFAILED: "SAVEPERFORMAINVOICEFAILED",// 
    GETACCIDENTTYPESUCCESS: "GETACCIDENTTYPESUCCESS",
    GETACCIDENTTYPEBYIDSUCCESS: "GETACCIDENTTYPEBYIDSUCCESS",
    GETACCIDENTTYPEBYIDFAILED: "GETACCIDENTTYPEBYIDFAILED",
    GETACCIDENTTYPEFAILED: "GETACCIDENTTYPEFAILED",
    UPDATEACCIDENTTYPE: "UPDATEACCIDENTTYPE",
    UPDATEACCIDENTTYPESUCCESS: "UPDATEACCIDENTTYPESUCCESS",
    UPDATEACCIDENTTYPEFAILED: "UPDATEACCIDENTTYPEFAILED",
    SAVEACCIDENTTYPE: "SAVEACCIDENTTYPE",
    SAVEACCIDENTTYPESUCCESS: "SAVEACCIDENTTYPESUCCESS",
    SAVEACCIDENTTYPEFAILED: "SAVEACCIDENTTYPEFAILED",// 
    GETDRIVERSUCCESS: "GETDRIVERSUCCESS",
    GETDRIVERBYIDSUCCESS: "GETDRIVERBYIDSUCCESS",
    GETDRIVERBYIDFAILED: "GETDRIVERBYIDFAILED",
    GETDRIVERFAILED: "GETDRIVERFAILED",
    UPDATEDRIVER: "UPDATEDRIVER",
    UPDATEDRIVERSUCCESS: "UPDATEDRIVERSUCCESS",
    UPDATEDRIVERFAILED: "UPDATEDRIVERFAILED",
    SAVEDRIVER: "SAVEDRIVER",
    SAVEDRIVERSUCCESS: "SAVEDRIVERSUCCESS",
    SAVEDRIVERFAILED: "SAVEDRIVERFAILED",// 
    GETREPLACEABLEVEHICLESUCCESS: "GETREPLACEABLEVEHICLESUCCESS",
    GETREPLACEABLEVEHICLEBYIDSUCCESS: "GETREPLACEABLEVEHICLEBYIDSUCCESS",
    GETREPLACEABLEVEHICLEBYIDFAILED: "GETREPLACEABLEVEHICLEBYIDFAILED",
    GETREPLACEABLEVEHICLEFAILED: "GETREPLACEABLEVEHICLEFAILED",
    UPDATEREPLACEABLEVEHICLE: "UPDATEREPLACEABLEVEHICLE",
    UPDATEREPLACEABLEVEHICLESUCCESS: "UPDATEREPLACEABLEVEHICLESUCCESS",
    UPDATEREPLACEABLEVEHICLEFAILED: "UPDATEREPLACEABLEVEHICLEFAILED",
    SAVEREPLACEABLEVEHICLE: "SAVEREPLACEABLEVEHICLE",
    SAVEREPLACEABLEVEHICLESUCCESS: "SAVEREPLACEABLEVEHICLESUCCESS",
    SAVEREPLACEABLEVEHICLEFAILED: "SAVEREPLACEABLEVEHICLEFAILED",// 
    GETVEHICLEREPLACEMENTSUCCESS: "GETVEHICLEREPLACEMENTSUCCESS",
    GETLEASEPLANSUCCESS: "GETLEASEPLANSUCCESS",
    GETVEHICLEREPLACEMENTBYIDSUCCESS: "GETVEHICLEREPLACEMENTBYIDSUCCESS",
    GETVEHICLEREPLACEMENTBYIDFAILED: "GETVEHICLEREPLACEMENTBYIDFAILED",
    GETTECHNICALREPORTBYIDSUCCESS: "GETTECHNICALREPORTBYIDSUCCESS",
    GETTECHNICALREPORTBYIDFAILED: "GETTECHNICALREPORTBYIDFAILED",
    GETVEHICLEREPLACEMENTBYDRIVERIDSUCCESS: "GETVEHICLEREPLACEMENTBYDRIVERIDSUCCESS",
    GETVEHICLEREPLACEMENTBYDRIVERIDFAILED: "GETVEHICLEREPLACEMENTBYDRIVERIDFAILED",
    GETVEHICLEREPLACEMENTFAILED: "GETVEHICLEREPLACEMENTFAILED",
    GETLEASEPLANFAILED: "GETLEASEPLANFAILED",
    UPDATEVEHICLEREPLACEMENT: "UPDATEVEHICLEREPLACEMENT",
    UPDATEVEHICLEREPLACEMENTSUCCESS: "UPDATEVEHICLEREPLACEMENTSUCCESS",
    UPDATEVEHICLEREPLACEMENTFAILED: "UPDATEVEHICLEREPLACEMENTFAILED",
    SAVEVEHICLEREPLACEMENT: "SAVEVEHICLEREPLACEMENT",
    SAVEVEHICLEREPLACEMENTSUCCESS: "SAVEVEHICLEREPLACEMENTSUCCESS",
    SAVEVEHICLEREPLACEMENTFAILED: "SAVEVEHICLEREPLACEMENTFAILED",// 
    GETBATCHSUCCESS: "GETBATCHSUCCESS",
    GETBATCHBYIDSUCCESS: "GETBATCHBYIDSUCCESS",
    GETBATCHBYIDFAILED: "GETBATCHBYIDFAILED",
    GETBATCHFAILED: "GETBATCHFAILED",
    UPDATEBATCH: "UPDATEBATCH",
    UPDATEBATCHSUCCESS: "UPDATEBATCHSUCCESS",
    UPDATEBATCHFAILED: "UPDATEBATCHFAILED",
    SAVEBATCH: "SAVEBATCH",
    SAVEBATCHSUCCESS: "SAVEBATCHSUCCESS",
    SAVEBATCHFAILED: "SAVEBATCHFAILED",// 
    GETLEASEBATCHSUCCESS: "GETLEASEBATCHSUCCESS",
    GETLEASEBATCHBYIDSUCCESS: "GETLEASEBATCHBYIDSUCCESS",
    GETLEASEBATCHBYIDFAILED: "GETLEASEBATCHBYIDFAILED",
    GETLEASEBATCHFAILED: "GETLEASEBATCHFAILED",
    UPDATELEASEBATCH: "UPDATELEASEBATCH",
    UPDATELEASEBATCHSUCCESS: "UPDATELEASEBATCHSUCCESS",
    UPDATELEASEBATCHFAILED: "UPDATELEASEBATCHFAILED",
    SAVELEASEBATCH: "SAVELEASEBATCH",
    SAVELEASEBATCHSUCCESS: "SAVELEASEBATCHSUCCESS",
    SAVELEASEBATCHFAILED: "SAVELEASEBATCHFAILED",// 
    GETPARALLELJOBSUCCESS: "GETPARALLELJOBSUCCESS",
    GETPARALLELJOBBYIDSUCCESS: "GETPARALLELJOBBYIDSUCCESS",
    GETPARALLELJOBBYIDFAILED: "GETPARALLELJOBBYIDFAILED",
    GETPARALLELJOBFAILED: "GETPARALLELJOBFAILED",
    UPDATEPARALLELJOB: "UPDATEPARALLELJOB",
    UPDATEPARALLELJOBSUCCESS: "UPDATEPARALLELJOBSUCCESS",
    UPDATEPARALLELJOBFAILED: "UPDATEPARALLELJOBFAILED",
    SAVEPARALLELJOB: "SAVEPARALLELJOB",
    SAVEPARALLELJOBSUCCESS: "SAVEPARALLELJOBSUCCESS",
    SAVEPARALLELJOBFAILED: "SAVEPARALLELJOBFAILED",// 
}

export async function getServerSideProps(context) {
    return {
        props: {},
    };
}

export default ActionTypes;